<template>

  <section id="card-navigation">
    <b-alert
      show
      variant="warning"
    >
      <div class="alert-body text-center">
        <feather-icon
          id="alert"
          class="mr-25"
          icon="AlertTriangleIcon"
        />
        <span
          id="giris"
          class="ml-25"
        >Sektör Adını Görüntülemek İçin Cihaz Ekleme Panelinden Cihaz Kaydı Oluşturmanız Gerekmektedir. </span>
        <span><a href="./cihazlar">Sayfaya Git</a></span>
      </div>
    </b-alert>
    <div>
      <b-form-select
        id="baslik"
        v-model="selected"
        :options="options"
      />
      <b-card-text class="mt-1 mb-0" />
    </div>
    <b-row>

      <!-- pill tabs inside card -->
      <b-col

        md="6"
      >
        <b-card
          class="text-center"
        >
          <b-tabs
            pills
            nav-class="mb-3"
          >
            <b-spinner
              small
              type="grow"
              label="Loading..."
              variant="success"
            />
            <b-tab
              title="As Plastik"
              active
            >
              <b-card-title>
                <small> Cihaz Seri No:</small><h2 style="color:red;">
                  4522685
                </h2>
              </b-card-title>

              <b-list-group>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <span>Role Durumu</span>
                  <font-awesome-icon icon="fa-solid fa-industry-windows" />
                  <h5 style="color:green;">
                    Aktif
                  </h5>
                </b-list-group-item>

                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <feather-icon
                    icon="WifiIcon"
                    scale="2"
                    size="18"
                    variant="success"
                  />
                  <h5 style="color:green;">
                    Bağlantı Başarılı
                  </h5>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <feather-icon
                    icon="BatteryChargingIcon"
                    scale="2"
                    size="22"
                    variant="success"
                  />
                  Kapasitif Güç: 240 kWh
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <img
                    :src="image"
                    style="width:4%;"
                    alt=""
                  >
                  TR9
                </b-list-group-item>
                <b-list-group-item
                  class="d-flex justify-content-between align-items-center"
                  href="https://www.google.com"
                  target="www.google.com"
                >
                  <feather-icon
                    icon="MapPinIcon"
                    size="18"
                  />
                  Menekse Cad.İstiklal Sokak-
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <b-button
                    id="kaydir"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    v-b-modal.modal
                    variant="secondary"
                  >
                    İşlem Yap
                  </b-button>

                  <!-- modal -->
                  <b-modal
                    id="modal"
                    title="BootstrapVue"
                    cancel-enable
                    ok-enable
                    cancel-title="Kapat"
                    cancel-variant="outline-secondary"
                    ok-title="Tamam"
                  >
                    <b-card-text>
                      Tootsie roll oat cake I love bear claw I love caramels caramels halvah chocolate bar. Cotton candy gummi bears
                      pudding pie apple pie cookie. Cheesecake jujubes lemon drops danish dessert I love caramels powder.
                    </b-card-text>
                  </b-modal>
                </b-list-group-item>
              </b-list-group>
              <b-card-text />
            </b-tab>

          </b-tabs>
        </b-card>
      </b-col>
      <b-col

        md="6"
      >
        <b-card
          class="text-center"
        >
          <b-tabs
            pills
            nav-class="mb-3"
          >
            <b-spinner
              small
              type="grow"
              label="Loading..."
              variant="success"
            />
            <b-tab
              title="Atlas Dericilik"
              active
            >
              <b-card-title>
                <small> Cihaz Seri No:</small><h2 style="color:red;">
                  4528562
                </h2>
              </b-card-title>

              <b-list-group>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <span>Role Durumu</span>

                  <b style="color:green;">Aktif</b>

                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <feather-icon
                    icon="WifiIcon"
                    scale="2"
                    size="18"
                    variant="success"
                  />
                  <h5 style="color:green;">
                    Bağlantı Başarılı
                  </h5>                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <feather-icon
                    icon="BatteryChargingIcon"
                    scale="2"
                    size="20"
                    variant="success"
                  />

                  Kapasitif Güç: 256 kWh

                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <img
                    :src="image"
                    style="width:4%;"
                    alt="trafo"
                  >
                  TR28
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <feather-icon
                    icon="MapPinIcon"
                    size="18"
                  />
                  Sakarya Cad.Aliz Sokak-- Niğde
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <b-button id="kaydir">
                    İşlem Yap
                  </b-button>
                </b-list-group-item>
              </b-list-group>
              <b-card-text />

            </b-tab>

          </b-tabs>
        </b-card>
      </b-col>
      <b-col

        md=""
      >
        <b-card
          class="text-center"
        >
          <b-tabs
            pills
            nav-class="mb-3"
          >
            <b-spinner
              small
              type="grow"
              label="Loading..."
              variant="danger"
            />
            <b-tab
              title="Aktif Cihaz 3"
              active
            >
              <b-card-title>
                <small> Cihaz Seri No:</small><h2 style="color:red;">
                  4528149
                </h2>
              </b-card-title>

              <b-list-group>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <span>Role Durumu</span>
                  <b style="color:red;">Aktif Değil</b>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <feather-icon
                    icon="WifiIcon"
                    scale="2"
                    size="16"
                    variant="danger"
                  />
                  <h5
                    class="online"
                    style="color:red;"
                  >
                    Bağlantı Hatası/Bağlantıları Kontrol Ediniz
                  </h5>                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <feather-icon
                    icon="BatteryChargingIcon"
                    scale="2"
                    size="18"
                    variant="success"
                  />

                  Kapasitif Güç: 256 kWh

                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <img
                    :src="image"
                    style="width:4%;"
                    alt="trafo"
                  >
                  TR6
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <feather-icon
                    icon="MapPinIcon"
                    size="18"
                  />
                  Burdur Cad.Krip Sokak-- Ankara
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <b-button id="kaydir">
                    İşlem Yap
                  </b-button>

                </b-list-group-item>
              </b-list-group>
              <b-card-text />

            </b-tab>

          </b-tabs>
        </b-card>
      </b-col>
      <b-col

        md=""
      >
        <b-card
          class="text-center"
        >
          <b-tabs
            pills
            nav-class="mb-3"
          >
            <b-spinner
              small
              type="grow"
              label="Loading..."
              variant="danger"
            />
            <b-tab
              title="Aktif Cihaz 4 "
              active
            >
              <b-card-title>
                <small> Cihaz Seri No:</small><h2 style="color:red;">
                  4528149
                </h2>
              </b-card-title>

              <b-list-group>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <span>Role Durumu</span>
                  <b style="color:red;">Aktif Değil</b>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <feather-icon
                    icon="WifiIcon"
                    scale="2"
                    variant="danger"
                    size="17"
                  />
                  <h5
                    class="online"
                    style="color:red;"
                  >
                    Bağlantı Hatası/Bağlantıları Kontrol Ediniz
                  </h5>                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <feather-icon
                    icon="BatteryChargingIcon"
                    scale="2"
                    size="18"
                    variant="success"
                  />

                  Kapasitif Güç: 256 kWh

                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <img
                    :src="image"
                    style="width:4%;"
                    alt="trafo"
                  >
                  TR6
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <feather-icon
                    icon="MapPinIcon"
                    size="17"
                  />
                  Burdur Cad.Krip Sokak-- Ankara
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  <b-button id="kaydir">
                    İşlem Yap
                  </b-button>

                </b-list-group-item>
              </b-list-group>
              <b-card-text />

            </b-tab>

          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import {
  BRow, BCol, BCard, BTab, BTabs, BCardText, BCardTitle, BListGroupItem,
  BListGroup, BSpinner, BButton, BFormSelect, BAlert, BModal,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BTab,
    BTabs,
    BCardText,
    BCardTitle,
    BListGroupItem,
    BListGroup,
    BSpinner,
    BButton,
    BFormSelect,
    BAlert,
    BModal,

  },
  directives: {
    Ripple,
  },
  data() {
    return {
      selected: null,
      options: [
        { value: null, text: 'Tümünü Görüntüle' },

        { value: 'a', text: 'As Plastik' },
        { value: 'b', text: 'Atlas Dericilik' },

      ],
      image: 'https://cdn-icons-png.flaticon.com/512/649/649915.png',
    }
  },
}
</script>
<style>
#kaydir{
  float: right;
width: 100%;
}
#secim{
  float: right;
}
#baslik
{
  background-color: bisque;
  color: rgb(0, 0, 0);
}
#giris{
  color:blue;
}
#alert{
  color: blue;
}
</style>
